/**
 * ====================
 * SECTION 1: PLAY BUTTON
 * ====================
 */ const videoHTML = '<lite-youtube class="w-full h-auto rounded shadow-md" videoid="p3lhXLX9Fjs"></lite-youtube>';
const modal = new tingle.modal({
    closeMethods: [
        "overlay",
        "button",
        "escape"
    ],
    closeLabel: "Cerrar",
    beforeClose: ()=>{
        // Before the modal is closed, you have to close the video too (so that the audio doesn't stay playing)
        modal.setContent(videoHTML);
        // Process to close the modal.
        return true;
    }
});
modal.setContent(videoHTML);
const playButton = document.getElementById("play-button");
playButton.addEventListener("click", ()=>modal.open());
/**
 * ====================
 * SECTION 7: TESTIMONIALS SLIDER
 * ====================
 */ tns({
    container: "#testimonials-slider",
    responsive: {
        0: {
            items: 2
        },
        640: {
            items: 3
        }
    },
    speed: 300,
    autoplay: true,
    autoplayHoverPause: false,
    autoplayTimeout: 2500,
    autoplayButtonOutput: false,
    mouseDrag: false,
    nav: false,
    controls: false,
    center: false
});
/**
 * ====================
 * WHATSAPP BUTTON WHEN SCROLL
 * ====================
 */ const section2 = document.getElementById("que-es");
const floatingWhatsAppButton = document.getElementById("whatsapp-floating-btn");
document.addEventListener("scroll", ()=>{
    if (document.documentElement.scrollTop >= section2.offsetTop) {
        if (floatingWhatsAppButton.classList.contains("hidden")) {
            floatingWhatsAppButton.classList.remove("hidden");
            floatingWhatsAppButton.classList.add("fadeInRight");
            setTimeout(()=>floatingWhatsAppButton.classList.remove("fadeInRight"), 1000);
        }
    } else if (!floatingWhatsAppButton.classList.contains("hidden")) {
        floatingWhatsAppButton.classList.add("fadeInRightToDissapear");
        setTimeout(()=>{
            floatingWhatsAppButton.classList.remove("fadeInRightToDissapear");
            floatingWhatsAppButton.classList.add("hidden");
        }, 1000);
    }
});
/**
 * ====================
 * MOBILE NAVBAR
 * ====================
 */ const mobileMenu = document.getElementById("mobile-menu");
const mobileMenuOpenBtn = document.getElementById("mobile-menu-open");
const mobileMenuCloseBtn = document.getElementById("mobile-menu-close");
mobileMenuOpenBtn.addEventListener("click", (e)=>{
    e.preventDefault();
    mobileMenu.classList.remove("hidden");
    mobileMenu.classList.add("mobileMenuFadeInLeft");
    setTimeout(()=>{
        mobileMenu.classList.remove("mobileMenuFadeInLeft");
    }, 500);
    document.body.style.overflow = "hidden";
    document.getElementById("desktop-menu-overlay").classList.remove("hidden");
});
mobileMenuCloseBtn.addEventListener("click", (e)=>{
    e.preventDefault();
    mobileMenu.classList.add("mobileMenuFadeInRight");
    setTimeout(()=>{
        mobileMenu.classList.remove("mobileMenuFadeInRight");
        mobileMenu.classList.add("hidden");
    }, 500);
    document.body.style.overflow = "auto";
    document.getElementById("desktop-menu-overlay").classList.add("hidden");
});
/**
 * ====================
 * DESKTOP NAVBAR
 * ====================
 */ const desktopNavbarMenu = document.getElementById("desktop-navbar-menu");
const desktopMenuOverlay = document.getElementById("desktop-menu-overlay");
const openDesktopNavbarMenu = document.getElementById("open-desktop-navbar-menu");
const closeDesktopNavbarMenu = document.getElementById("close-desktop-navbar-menu");
// Open desktop navbar menu action.
openDesktopNavbarMenu.addEventListener("click", (e)=>{
    e.preventDefault();
    desktopNavbarMenu.classList.remove("hidden");
    desktopNavbarMenu.classList.add("desktopNavbarFadeInRight");
    setTimeout(()=>desktopNavbarMenu.classList.remove("desktopNavbarFadeInRight"), 500);
    document.body.style.overflow = "hidden";
    desktopMenuOverlay.classList.remove("hidden");
});
// Close desktop navbar menu action.
closeDesktopNavbarMenu.addEventListener("click", (e)=>{
    e.preventDefault();
    desktopNavbarMenu.classList.add("desktopNavbarFadeInLeft");
    setTimeout(()=>{
        desktopNavbarMenu.classList.remove("desktopNavbarFadeInLeft");
        desktopNavbarMenu.classList.add("hidden");
    }, 500);
    document.body.style.overflow = "auto";
    desktopMenuOverlay.classList.add("hidden");
});
desktopMenuOverlay.addEventListener("click", (e)=>{
    e.preventDefault();
    // Check if there is open the desktop menu or the mobile menu:
    if (!desktopNavbarMenu.classList.contains("hidden")) {
        desktopNavbarMenu.classList.add("desktopNavbarFadeInLeft");
        setTimeout(()=>{
            desktopNavbarMenu.classList.remove("desktopNavbarFadeInLeft");
            desktopNavbarMenu.classList.add("hidden");
        }, 500);
        document.body.style.overflow = "auto";
    } else {
        mobileMenu.classList.add("mobileMenuFadeInRight");
        setTimeout(()=>{
            mobileMenu.classList.remove("mobileMenuFadeInRight");
            mobileMenu.classList.add("hidden");
        }, 500);
    }
    desktopMenuOverlay.classList.add("hidden");
});

//# sourceMappingURL=repo.612ff215.js.map
